import { render, staticRenderFns } from "./wcsd.vue?vue&type=template&id=2dc4a323&scoped=true&"
import script from "./wcsd.vue?vue&type=script&lang=js&"
export * from "./wcsd.vue?vue&type=script&lang=js&"
import style0 from "./wcsd.vue?vue&type=style&index=0&id=2dc4a323&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc4a323",
  null
  
)

export default component.exports